module.exports = __webpack_public_path__ + "img/fossil2Img2.83e951c0.jpg";